import { Game } from '../src/PlayToEarn/models/Game'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Link from 'next/link'
import { isEqual } from 'lodash'
import { DiscordServer } from '../src/Social/data/allSocialChannelTypes'
import { GameSocialChannel } from '../src/PlayToEarn/models/GameSocialChannel'

type GameCardProps = { game: Game }

export function GameCard(props: GameCardProps) {
  const { game } = props
  const discord: GameSocialChannel | undefined = game.channels.find(channel => isEqual(channel.type, DiscordServer))
  const subsCount = discord ? discord.subscriberCount : 0
  return (
    <Card>
      <Card.Img variant="top" src={game.image} />
      <Card.Body>
        <Card.Title>{game.name}</Card.Title>
        {game.description ? <Card.Text>{game.description}</Card.Text> : undefined}
        <p>Discord: {subsCount}</p>
        <Link href={`/play-to-earn/games/${game.id}`} passHref><Button variant="primary">Learn more</Button></Link>
      </Card.Body>
    </Card>
  )
}
